module.exports = __webpack_public_path__ + "static/media/nav-personality-inactive.8c8c1b20.svg";